<script setup>
import { ref } from 'vue';

import AppMenuItem from './AppMenuItem.vue';

const model = ref([
    {
        items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/app/dashboard' }]
    },
    {
        label: 'Onboarding',
        items: [
            { label: 'Banners', icon: 'pi pi-fw pi-images', to: '/app/onboarding/banners' },
            { label: 'Vouchers', icon: 'pi pi-fw pi-ticket', to: '/app/onboarding/vouchers' }
        ]
    },
    {
        label: 'Customers',
        items: [{ label: 'Customers', icon: 'pi pi-fw pi-users', to: '/app/customers' }]
    },
    {
        label: 'Products',
        items: [
            { label: 'Categories', icon: 'pi pi-fw pi-tags', to: '/app/categories' },
            { label: 'Products', icon: 'pi pi-fw pi-th-large', to: '/app/products' },
            { label: 'Sizes', icon: 'pi pi-fw pi-minus-circle', to: '/app/sizes' },
            { label: 'Colors', icon: 'pi pi-fw pi-circle-fill', to: '/app/colors' }
        ]
    },
    {
        label: 'Transactions',
        items: [{ label: 'Transactions', icon: 'pi pi-fw pi-receipt', to: '/app/transactions' }]
    },
    {
        label: 'Post',
        items: [{ label: 'Articles', icon: 'pi pi-fw pi-book', to: '/app/articles' }]
    },
    {
        label: 'Settings',
        items: [{ label: 'Settings', icon: 'pi pi-fw pi-cog', to: '/app/settings' }]
    }
]);

const env = import.meta.env.VITE_APP_APP_ENV;
</script>

<template>
    <div class="sidebar-container h-screen w-full text-white p-2 px-4">
        <h1 class="text-2xl font-bold mb-4 d-sm text-white">{{ $store.state.setting?.app_name }}</h1>
        <ul class="layout-menu">
            <template v-for="(item, i) in model" :key="item">
                <div class="menu-section">
                    <div class="layout-menuitem-root-text font-bold">{{ item.label }}</div>
                    <app-menu-item v-if="!item.separator" :item="item" :index="i" class="my-3"></app-menu-item>
                </div>
                <li v-if="item.separator" class="menu-separator"></li>
            </template>
            <li v-if="env == 'demo'">
                <a href="https://wa.me/6282299265151" target="_blank">
                    <img src="/layout/images/banner-demo.svg" alt="Contact Us" class="w-full mt-3" />
                </a>
            </li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
.sidebar-container {
    .layout-menu {
        @apply space-y-6;
    }

    .menu-section {
        @apply space-y-2;
    }

    :deep(.menu-separator) {
        @apply my-2 border-t border-blue-500;
    }

    :deep(.layout-menuitem-root-text) {
        @apply text-sm text-gray-100 font-medium;
    }
}
.sidebar-container {
    background-color: var(--sidebar-bg-color, #0663ca);
}
.dark .sidebar-container {
    --sidebar-bg-color: inherit;
}
</style>
